import { Feature } from 'entities/campaign/features';
import { ValidNonScheduledType } from 'entities/campaign/rulesets/channels';
import { SubFeature } from 'entities/campaign/rulesets/subfeatures';
import { TFunction } from 'react-i18next';

export interface RulesetConfig {
  availableChannelTypes: ValidNonScheduledType[];
  defaultTemplateId?: string;
  multipleChannelsAllowed: boolean;
  title: string;
}

const RulesetConfigs: (
  translator: TFunction<'campaigns'>,
) => { [feature in Feature]: { [subFeature in SubFeature]?: RulesetConfig } } = (
  translator: TFunction<'campaigns'>,
) => ({
  'Marketing Permission': {
    EMAIL_OPT_IN: {
      availableChannelTypes: ['.RTMInjectedChannel', '.RTMOverlayChannel'],
      multipleChannelsAllowed: false,
      title: translator('editor.rulesetConfig.marketingPermissions.title.emailOptInRTM'),
    },
    EMAIL_CONFIRMED_OPT_IN: {
      availableChannelTypes: ['.RTMInjectedChannel', '.RTMOverlayChannel'],
      multipleChannelsAllowed: false,
      title: translator('editor.rulesetConfig.marketingPermissions.title.emailConfirmedOptInRTM'),
    },
    EMAIL_OPT_OUT: {
      availableChannelTypes: ['.RTMInjectedChannel', '.RTMOverlayChannel'],
      multipleChannelsAllowed: false,
      title: translator('editor.rulesetConfig.marketingPermissions.title.emailOptOutRTM'),
    },
    SMS_OPT_IN: {
      availableChannelTypes: ['.RTMInjectedChannel', '.RTMOverlayChannel'],
      multipleChannelsAllowed: false,
      title: translator('editor.rulesetConfig.marketingPermissions.title.smsOptInRTM'),
    },
    SMS_OPT_OUT: {
      availableChannelTypes: ['.RTMInjectedChannel', '.RTMOverlayChannel'],
      multipleChannelsAllowed: false,
      title: translator('editor.rulesetConfig.marketingPermissions.title.smsOptOutRTM'),
    },
  },
  'Cart Abandonment': {
    REMINDER: {
      availableChannelTypes: ['.Email'],
      defaultTemplateId: null,
      multipleChannelsAllowed: true,
      title: translator('editor.rulesetConfig.cartAbandonment.reminder.title'),
    },
  },
  'Browse Abandonment': {
    REMINDER: {
      availableChannelTypes: ['.Email'],
      defaultTemplateId: null,
      multipleChannelsAllowed: true,
      title: translator('editor.rulesetConfig.browseAbandonment.reminder.title'),
    },
  },
  TestFeature1: {},
  TestFeature2: {},
});

export const getRulesetConfig = (
  feature: Feature,
  subFeature: SubFeature,
  translator: TFunction<'campaigns'>,
): RulesetConfig => RulesetConfigs(translator)[feature][subFeature];
